/** 面包屑组件的附加通知和按钮hook */
import type { Component } from 'vue'
/** 附加通知文本 */
const notification = ref('')
/** 点击附加通知的回调 */
let clickCb: () => boolean

export const notifier = {
  /** 推送通知 */
  notify(text: string) {
    notification.value = text
    return notifier
  },
  /** 点击通知 */
  click() {
    const bool = clickCb && clickCb()
    if (bool) notifier.clear() // 回调返回true 清除通知
    return notifier
  },
  /** 注册点击回调 */
  onClick(cb: typeof clickCb) {
    clickCb = cb
    return notifier
  },
  /** 清除通知 */
  clear() {
    notification.value = ''
  },
  /** 获取通知 */
  get() {
    return notification.value
  }
}
/** 附加按钮组件 */
const component = ref<Nullable<Component>>(null)

export const operation = {
  /** 添加组件 */
  add(btn: Component) {
    component.value = markRaw(btn)
    return operation
  },
  /** 清除组件 */
  clear() {
    component.value = null
    return operation
  },
  /** 获取组件 */
  get() {
    return component.value
  }
}

/** 头部提醒组件 */
const componentTop = ref<Nullable<Component>>(null)

export const topTip = {
  /** 添加组件 */
  add(btn: Component) {
    componentTop.value = markRaw(btn)
    return topTip
  },
  /** 清除组件 */
  clear() {
    componentTop.value = null
    return topTip
  },
  /** 获取组件 */
  get() {
    return componentTop.value
  }
}
